<template>
  <div class="printstore-ad">
    <div class="shade"></div>

    <h1 :style="{ color: psColor }">{{ title }}</h1>
    <ul class="ad-container">
      <li class="button-holder">
        <button
          :style="{ backgroundColor: psColor }"
          class="more-button"
          @click="goToPrintStore"
        >
          MEER...
        </button>
      </li>

      <li v-if="mainProduct.id">
        <button @click="goToMainProduct()">
          <img :class="classObjectMainProduct" :src="setImgUrl(mainProduct)" />
        </button>
      </li>

      <li v-for="product in products" :key="product.id">
        <button @click="goToProduct(product)">
          <img :class="classObjectProduct(product)" :src="setImgUrl(product)" />
        </button>
      </li>
    </ul>
  </div>
</template>

<script>
import {
  getRandomPrintStoreProducts,
  getProduct
} from '@/features/printstore/PrintStoreApi'

export default {
  data() {
    return {
      products: [],
      mainProduct: {}
    }
  },
  async created() {
    getRandomPrintStoreProducts(20, '').then((resp) => {
      this.products = resp
    })
    if (this.rootStore.theme.customFields.printStoreAd.footerMainProduct) {
      this.mainProduct = await getProduct(
        this.rootStore.theme.customFields.printStoreAd.footerMainProduct
      )
    }
  },
  computed: {
    title() {
      return this.rootStore.theme.customFields.printStoreAd.footerTitle
    },
    psColor() {
      return this.rootStore.theme.customFields.printStore.color
    },
    classObjectMainProduct() {
      return {
        border:
          this.mainProduct.displaySpecification &&
          this.mainProduct.displaySpecification.border
            ? true
            : false
      }
    }
  },
  methods: {
    classObjectProduct(product) {
      return {
        border:
          product.displaySpecification && product.displaySpecification.border
            ? true
            : false
      }
    },
    setImgUrl(product) {
      const printStoreId = product.printStoreId

      // Get random preview image if there are variants
      const image =
        product.hasVariants && product.previews.length > 0
          ? product.previews[
              Math.floor(Math.random() * product.previews.length)
            ].uuid
          : product.previewImage

      return image
        ? `/media/print-store/${printStoreId}/preview/${image}/125`
        : ''
    },
    goToPrintStore() {
      if (this.rootStore.theme.customFields.printStoreAd.footerLink) {
        this.$router.push({
          name: 'printStoreCategory',
          params: {
            categoryId: this.rootStore.theme.customFields.printStoreAd
              .footerLink
          }
        })
      } else {
        this.$router.push({ name: 'printStore' })
      }
    },
    goToProduct(product) {
      this.$router.push({
        name: 'printStoreProduct',
        params: {
          categoryId: product.collections[0].categoryId,
          collectionId: product.collections[0].id,
          productId: product.id
        }
      })
    },
    goToMainProduct() {
      this.$router.push({
        name: 'printStoreProduct',
        params: {
          categoryId: this.mainProduct.categoryId,
          collectionId: this.mainProduct.collections[0].id,
          productId: this.mainProduct.id
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.printstore-ad {
  background: white;
  //  top: calc(100vh - 212px);
  //  position: fixed;
  padding-top: 23px;
  overflow: hidden;
  //  left: calc(50% - 2982px);
  width: 5964px;
  height: 5964px;
  border-radius: 50%;
}

.shade {
  border-radius: 50%;
  box-shadow: rgba(0, 0, 0, 0.22) 4px 13px 24px inset;

  position: absolute;
  pointer-events: none;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

h1 {
  font-size: 20px;
  font-weight: 500;
  text-align: center;
  color: var(--sub-color);
}

.ad-container {
  display: flex;
  flex-direction: row-reverse;
  width: 100vw;
  margin: 0 auto;
  gap: 40px;
  max-width: 1555px;
  padding: 0 35px;
  align-items: center;
}

li {
  max-width: 125px;
  max-height: 125px;

  img {
    max-height: 125px;
    width: auto;
    display: block;
  }
}

.button-holder {
  align-self: flex-end;
  line-height: 125px;
}

.border {
  border: 1px solid #c7c7c7;
}

.more-button {
  background-color: var(--sub-color);
  width: 125px;
  height: 35px;
  border-radius: 18px;
  color: white;
  font-weight: 600;
  font-size: 0.82rem;
  transition: box-shadow 0.25s;

  &:hover {
    box-shadow: rgba(0, 0, 0, 0.5) 0 0 7px 0;
  }
}
</style>
